export default __webpack_public_path__ + "686ee54f6bbfd58d58ca1f46a97e9a23.jpg";